import React from "react";
import "./TarifsSkeleton.scss";

/*
  Заглушка тарифов на время запроса: та же геометрия, что у настоящих
  карточек, поэтому когда данные приходят — ничего не двигается. Три
  карточки на десктопе, одна на ≤768 (остальные прячет css).
*/
const CARDS = [0, 1, 2];

const TarifsSkeleton = () => (
  <div className="tarifsSkeleton" aria-hidden="true">
    {CARDS.map((i) => (
      <div className="tarifsSkeleton_card" key={i}>
        <span className="tarifsSkeleton_bar tarifsSkeleton_bar--img" />
        <span className="tarifsSkeleton_bar tarifsSkeleton_bar--title" />
        <span className="tarifsSkeleton_bar tarifsSkeleton_bar--line" />
        <span className="tarifsSkeleton_bar tarifsSkeleton_bar--line" />
        <span className="tarifsSkeleton_bar tarifsSkeleton_bar--btn" />
      </div>
    ))}
  </div>
);

export default TarifsSkeleton;
